exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-info{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-17526aad!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Notification.vue
// module id = 850
// module chunks = 2